<script>
	import { getContext } from 'svelte';
    import { createEventDispatcher } from 'svelte'
	import { mapbox, key } from '../mapbox.js';
    import { yardMarkers } from '../../stores.js';
    import { reportYardImageError, getYardName } from '../../helpers.js';
    import { formatPhoneNumber } from '../../phoneUtils.js';

	const { getMap } = getContext(key);
	const map = getMap();

    const dispatch = createEventDispatcher()
    
    export let yard;

    const phoneHtml = yard.phone ? (formatPhoneNumber(yard.phone) + "<br>") : "";
    const popup = new mapbox.Popup({ offset: 25 }).setHTML(
        "<b>" + getYardName(yard) + "</b><br>" +
        phoneHtml +
        "<p style='font-size: xx-small; text-align: right; font-style: italic;'>right click for details</p>");
    
    function applyFallbackBadge(element) {
        element.classList.add('marker-fallback');
        element.style.backgroundImage = '';
        element.innerText = '🏭';
    }

    // Create a DOM element for the custom marker.
    const el = document.createElement('div');
    el.className = 'marker map-icon-marker';
    el.style.cursor = "pointer";

    // Check if yard image is empty or missing
    if (!yard.image || typeof yard.image !== 'string' || yard.image.trim() === '') {
        reportYardImageError(yard, "empty");
        applyFallbackBadge(el);
    } else {
        const imgPath = './assests/yards/' + yard.image;
        if (typeof Image !== 'undefined') {
            const testImg = new Image();
            testImg.onload = () => {
                el.style.backgroundImage = 'url(' + imgPath + ')';
            };
            testImg.onerror = () => {
                reportYardImageError(yard, "not_found", imgPath);
                // Apply fallback styling without wiping out Mapbox marker positioning classes
                applyFallbackBadge(el);
            };
            testImg.src = imgPath;
        } else {
            el.style.backgroundImage = 'url(' + imgPath + ')';
        }
    }

    let marker = new mapbox.Marker(el, {anchor: 'bottom'}).setLngLat([yard.address.coordinates.lng, yard.address.coordinates.lat]).setPopup(popup).addTo(map);

    marker._element.id = 'yard-marker-' + yard.id

    // this will highlight the yard in the left slidebar list of yards
    marker.getElement().addEventListener('mouseenter', () => {
            try {
                document.getElementById('yard-price-' + yard.id).style.backgroundColor = "#dcdbdb";
            } catch {
                // do nothing
            }
        });
    marker.getElement().addEventListener('mouseleave', () => {
        try {
            document.getElementById('yard-price-' + yard.id).style.backgroundColor = "";
        } catch { 
            // do nothing
        } 
        });

    // on double click, display the Yards edit form and prevent map zooming
    marker.getElement().addEventListener('dblclick', (e) => {
        e.preventDefault();
        e.stopPropagation();
        dispatch('yard-clicked');
    });

    // on rightclick, this will display the Yards form
    marker.getElement().addEventListener('contextmenu', async (e) => {
        e.preventDefault();
        dispatch('yard-clicked');
    });

    $yardMarkers = [...$yardMarkers, {
            marker: marker,
            label: yard.name,
            id: yard.id
        }];

</script>
